// $('.afsz-fullimagesM').slick({
//   lazyLoad: 'ondemand',
// 	slidesToShow: 1,
// 	slidesToScroll: 1,
// 	arrows: true,
// 	fade: true
//   // ,dots:true
// });
let slidesToScroll_pc = 5;
let page_url_afsz = window.location.href;

function isPdpGalleryDebug() {
  try {
    var q = new URLSearchParams(window.location.search).get("pdp_gallery_debug");
    return q === "1" || q === "true" || q === "yes";
  } catch (e) {
    return false;
  }
}

function normalizeGalleryFilterKey(col) {
  if (col == null || String(col).trim() === "") {
    return { newCol: "", selectedColor: "" };
  }
  var newCol = String(col);
  if (newCol.includes("+")) {
    newCol = newCol.split("+")[0];
  }
  if (newCol.includes("/")) {
    newCol = newCol.replace("/", "\\/");
  }
  var selectedColor = "." + newCol.trim();
  selectedColor = selectedColor.replaceAll(" ", "-");
  return { raw: String(col), newCol: newCol, selectedColor: selectedColor };
}

function extractGallerySlideClass($slide) {
  var cls = ($slide.attr("class") || "").split(/\s+/).filter(Boolean);
  var skip = {
    "afsz-fullimages__image": true,
    "afsz-thumbs__thumb": true,
    "slick-slide": true,
    "slick-cloned": true,
    "slick-active": true,
    "slick-current": true,
    "slick-center": true,
  };
  var keys = cls.filter(function (c) {
    if (skip[c]) return false;
    if (c.indexOf("slick-") === 0) return false;
    return true;
  });
  return keys.join(" ") || "(无额外 class)";
}

function getProductFormVariantId() {
  var $f = $("form.product-single__form, form[data-product-form]").first();
  if (!$f.length) {
    $f = $("form[action*='/cart/add']").first();
  }
  var $sel = $f.find("select[name=id]");
  if ($sel.length) {
    var v = String($sel.val() || "");
    if (v) return v;
  }
  var $hid = $f.find("input[name=id]").first();
  if ($hid.length) {
    var v2 = String($hid.val() || "");
    if (v2) return v2;
  }
  var $r = $f.find(".single-option-radio input.single-option-selector__radio:checked").first();
  if ($r.length) {
    return String($r.attr("data-var_id") || "");
  }
  return "";
}

function $pdpColorSwatchLabels() {
  return $(".options-color-wrapper").filter(function () {
    return $(this).find(".options-color.option-item").length > 0;
  });
}

function parseInlineBackground($el) {
  var st = ($el.attr("style") || "").replace(/\s+/g, " ");
  var m = st.match(/background\s*:\s*([^;]+)/i);
  return m ? m[1].trim() : "";
}

function updatePdpGalleryDebugPanel(col, selectedColor) {
  if (!isPdpGalleryDebug()) return;
  var $panel = $("#pdp-gallery-debug-panel");
  if (!$panel.length) {
    $("body").append(
      '<div id="pdp-gallery-debug-panel" style="position:fixed;bottom:12px;left:12px;max-width:min(96vw,640px);max-height:min(78vh,900px);overflow:auto;z-index:999999;background:#111;color:#e8e8e8;font:12px/1.45 Menlo,Consolas,monospace;padding:10px 12px;border-radius:8px;border:1px solid #444;box-shadow:0 8px 24px rgba(0,0,0,.4);">' +
        '<div style="color:#9cf;margin-bottom:6px;font-weight:700;">PDP 图库 &amp; 颜色调试 <span style="color:#888;font-weight:400;">?pdp_gallery_debug=1</span></div>' +
        '<div id="pdp-gallery-debug-body"></div></div>'
    );
    $panel = $("#pdp-gallery-debug-panel");
  }
  var norm = normalizeGalleryFilterKey(col);
  var filterKey = norm.selectedColor.indexOf(".") === 0 ? norm.selectedColor.slice(1) : norm.selectedColor;
  var $active = $pdpColorSwatchLabels().filter(".active").first();
  var formVid = getProductFormVariantId();
  var activeCount = $pdpColorSwatchLabels().filter(".active").length;
  var rows = [];
  rows.push("<div style='color:#fc8;margin:6px 0 2px'>传给 addSelectedColorImg 的 col</div>");
  rows.push("<div style='word-break:break-all'>" + escapeHtml(norm.raw) + "</div>");
  rows.push("<div style='color:#fc8;margin:8px 0 2px'>规范化后 jQuery / Slick 筛选选择器</div>");
  rows.push("<div style='word-break:break-all;color:#8f8'>" + escapeHtml(norm.selectedColor) + "</div>");
  rows.push("<div style='color:#fc8;margin:8px 0 2px'>当前 active 色块 data-*（.first）</div>");
  rows.push(
    "<div>data-title: <span style='color:#adf'>" +
      escapeHtml($active.attr("data-title") || "") +
      "</span></div>"
  );
  rows.push(
    "<div>data-option1: " + escapeHtml($active.attr("data-option1") || "") + "</div>"
  );
  rows.push(
    "<div>data-option2: " + escapeHtml($active.attr("data-option2") || "") + "</div>"
  );
  rows.push(
    "<div>data-var_id: " + escapeHtml($active.attr("data-var_id") || "") + "</div>"
  );
  rows.push(
    "<div style='margin-top:6px'>表单变体 id（select/input name=id）: <span style='color:#fc8;font-weight:700'>" +
      escapeHtml(formVid) +
      "</span></div>"
  );
  rows.push(
    "<div>active 色块数量: <span style='color:" +
      (activeCount === 1 ? "#6c6" : "#fc8") +
      ";font-weight:700'>" +
      activeCount +
      "</span>" +
      (activeCount !== 1 ? "（应为 1；多个会导致脚本读错充电/尺寸）" : "") +
      "</div>"
  );
  if (formVid && $active.attr("data-var_id") && String(formVid) !== String($active.attr("data-var_id"))) {
    rows.push(
      "<div style='color:#f88;margin-top:6px;font-weight:700'>不一致：表单变体 id ≠ 带 active 的色块 data-var_id → 图/文案/加购可能不同步，请点一次色块或检查 URL ?variant=</div>"
    );
  }
  rows.push(
    "<div style='margin-top:6px'>c-variant-selector value: <span style='color:#adf'>" +
      escapeHtml($(".c-variant-selector__swatches-wrapper").attr("value") || "") +
      "</span></div>"
  );

  rows.push("<div style='color:#9f6;margin:12px 0 4px;border-top:1px solid #444;padding-top:8px'>色块列表（product 表单内 .options-color-wrapper）</div>");
  rows.push("<table style='width:100%;border-collapse:collapse;font-size:11px'>");
  rows.push(
    "<tr style='color:#888'><th>#</th><th>显</th><th>active</th><th>chk</th><th>data-var_id</th><th>data-title→key</th><th>opt1</th><th>圆点 background</th><th>data-value</th></tr>"
  );
  var $form = $("form.product-single__form, form[data-product-form]").first();
  var $sw = $form.length
    ? $form.find(".options-color-wrapper")
    : $(".product-page .options-color-wrapper, .product_template_new .options-color-wrapper");
  var si = 0;
  $sw.each(function () {
    var $w = $(this);
    var forId = $w.attr("for");
    var $inp = $();
    if (forId && typeof document !== "undefined" && document.getElementById) {
      var node = document.getElementById(forId);
      if (node) {
        $inp = $(node);
      }
    }
    if (!$inp.length) {
      $inp = $w.prev("input[type=radio], input.single-option-selector__radio").first();
    }
    if (!$inp.length) {
      $inp = $w.siblings("input[type=radio]").first();
    }
    var chk = $inp.length ? !!$inp.prop("checked") : false;
    var dt = $w.attr("data-title") || "";
    var dtKey = normalizeGalleryFilterKey(dt).selectedColor;
    if (dtKey.indexOf(".") === 0) {
      dtKey = dtKey.slice(1);
    }
    var vis = $w.is(":visible");
    var isAct = $w.hasClass("active");
    var $dot = $w.find(".options-color.option-item, .option-item").first();
    var bg = parseInlineBackground($dot);
    var dval = $dot.attr("data-value") || $w.find(".option-item").first().attr("data-value") || "";
    si++;
    rows.push(
      "<tr><td style='padding:2px 4px;color:#888'>" +
        si +
        "</td><td>" +
        (vis ? "是" : "<span style='color:#888'>否</span>") +
        "</td><td style='color:" +
        (isAct ? "#6c6" : "#666") +
        "'>" +
        (isAct ? "Y" : "") +
        "</td><td>" +
        (chk ? "<span style='color:#6c6'>Y</span>" : "") +
        "</td><td style='word-break:break-all'>" +
        escapeHtml($w.attr("data-var_id") || "") +
        "</td><td style='word-break:break-all;color:#adf'>" +
        escapeHtml(dtKey) +
        "</td><td style='word-break:break-all'>" +
        escapeHtml($w.attr("data-option1") || "") +
        "</td><td style='word-break:break-all;color:#ccc'>" +
        escapeHtml(bg || "(空)") +
        "</td><td style='word-break:break-all'>" +
        escapeHtml(dval) +
        "</td></tr>"
    );
  });
  if (si === 0) {
    rows.push(
      "<tr><td colspan='9' style='padding:4px 0;color:#c66'>未找到表单内 .options-color-wrapper</td></tr>"
    );
  }
  rows.push("</table>");
  rows.push(
    "<div style='margin-top:4px;color:#888;font-size:11px'>圆点 background 来自主题 product_colors 与选项值匹配；为空则主题里缺该颜色键。data-title→key 应与上表「图库筛选器」一致才能出主图。</div>"
  );

  rows.push("<div style='color:#fc8;margin:12px 0 4px;border-top:1px solid #444;padding-top:8px'>主图 slide：class key（Liquid）与首图 alt</div>");
  rows.push("<table style='width:100%;border-collapse:collapse;margin-top:4px'>");
  rows.push(
    "<tr style='color:#888'><th style='text-align:left;padding:2px 6px 4px 0'>#</th><th style='text-align:left;padding:2px 6px'>slide class key</th><th style='text-align:left;padding:2px 6px'>首图 alt</th><th style='text-align:left;padding:2px 6px'>等于筛选器?</th></tr>"
  );
  var idx = 0;
  $(".afsz-prod-wrapper.fl .afsz-fullimages .afsz-fullimages__image").each(function () {
    var $sl = $(this);
    var key = extractGallerySlideClass($sl);
    var imgAlt = ($sl.find("img").first().attr("alt") || "").trim();
    var match = key === filterKey;
    idx++;
    rows.push(
      "<tr><td style='padding:2px 6px 2px 0;vertical-align:top;color:#888'>" +
        idx +
        "</td><td style='padding:2px 6px;word-break:break-all'>" +
        escapeHtml(key) +
        "</td><td style='padding:2px 6px;word-break:break-all;color:#ccc'>" +
        escapeHtml(imgAlt) +
        "</td><td style='padding:2px 6px;color:" +
        (match ? "#6c6" : "#c66") +
        ";font-weight:700'>" +
        (match ? "是" : "否") +
        "</td></tr>"
    );
  });
  if (idx === 0) {
    rows.push(
      "<tr><td colspan='4' style='padding:4px 0;color:#c66'>未找到 .afsz-prod-wrapper.fl .afsz-fullimages .afsz-fullimages__image（可能不是 fl 图库布局）</td></tr>"
    );
  }
  rows.push("</table>");
  rows.push(
    "<div style='margin-top:8px;color:#888;font-size:11px'>图库：媒体 Alt → split | → last → 空格改 - = slide class；Slick 用 data-title 同规则筛选。</div>"
  );

  $("#pdp-gallery-debug-body").html(rows.join(""));
}

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
if (page_url_afsz.indexOf("openmeetuc-pressure-relief-cushions") >= 0) {
  slidesToScroll_pc = 2;
}
if ($("body").hasClass("openfit2-plus-giftbox-benefits")) {
  slidesToScroll_pc = 6;
}
let fullImageSlick = $(".afsz-fullimages").slick({
  lazyLoad: "ondemand",
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  focusOnSelect: true,
  autoplay: true,
  arrows: true,
  dots: true,
  customPaging: function (slider, index) {
    console.log("slider", slider);
    return `${index + 1}/${slider.slideCount}`;
  },
  prevArrow:
    '<button type="button" class="slick-prev"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33301 1.33337L7.99967 8.00004L1.33301 14.6667" stroke="white" stroke-width="2"/></svg></button>',
  nextArrow:
    '<button type="button" class="slick-next"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33301 1.33337L7.99967 8.00004L1.33301 14.6667" stroke="white" stroke-width="2"/></svg></button>',
  asNavFor: ".afsz-thumbs",
});
let peopleFullImageSlick;
if($(".afsz-fullimages-people > .afsz-fullimages__image").length > 1) {
  peopleFullImageSlick = $(".afsz-fullimages-people").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    focusOnSelect: true,
    arrows: true,
    dots: true,
    customPaging: function (slider, index) {
      console.log("slider", slider);
      return `${index + 1}/${slider.slideCount}`;
    },
    prevArrow:
      '<button type="button" class="slick-prev"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33301 1.33337L7.99967 8.00004L1.33301 14.6667" stroke="white" stroke-width="2"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33301 1.33337L7.99967 8.00004L1.33301 14.6667" stroke="white" stroke-width="2"/></svg></button>',
    asNavFor: ".afsz-people-thumbs",
  });

   peopleFullImageSlick.slick('slickPause');
  $(".gallery-3d-wrapper").click(function() {
    setTimeout(() => {
    if($(this).find(".afsz-thumbs").hasClass("active")) {
      if(peopleFullImageSlick) {
        peopleFullImageSlick.slick('slickPause');
      }
      if(fullImageSlick) {
        fullImageSlick.slick('slickPlay');
      }
    }else if($(this).find(".afsz-people").hasClass("active")) {
      if(fullImageSlick) {
        fullImageSlick.slick('slickPause');
      }
      if(peopleFullImageSlick) {
        peopleFullImageSlick.slick('slickPlay');
      }
    }else if($(this).find(".afsz-video").hasClass("active")) {
      if(fullImageSlick) {
        fullImageSlick.slick('slickPause');
      }
      if(peopleFullImageSlick) {
        peopleFullImageSlick.slick('slickPause');
      }
    }
    }, 200);
    
  });

  
}

$(".afsz-thumbs").slick({
  lazyLoad: "ondemand",
  vertical: false,
  infinite: false,
  fade: true,
  asNavFor: ".afsz-fullimages",
  slidesToShow: 1,
  slidesToScroll: 1,
  focusOnSelect: true,
});
$(".afsz-people-thumbs").slick({
  lazyLoad: "ondemand",
  vertical: false,
  infinite: false,
  fade: true,
  prevArrow: false,
  nextArrow: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  focusOnSelect: true,
  asNavFor: ".afsz-fullimages-people",
});

$("[data-switch]").click(function () {
  $(`[data-switch]`).removeClass("active");
  $(this).addClass("active");
  $(`[data-switch-main]`).removeClass("active");
  $(`[data-switch-main="${$(this).data("switch")}"]`).addClass("active");

  $(".afsz-prod-wrapper").removeClass("has-show-3d active-3d");
  if ($(this).data("switch") == "people") {
    if(peopleFullImageSlick) {
      peopleFullImageSlick.slick(
        "slickGoTo",
        peopleFullImageSlick.slick("slickCurrentSlide")
      );

    }
  }
  if ($(this).data("switch") == "product") {
    fullImageSlick.slick(
      "slickGoTo",
      fullImageSlick.slick("slickCurrentSlide")
    );
    $(".afsz-prod-gallery").addClass("is-product");
  } else {
    $(".afsz-prod-gallery").removeClass("is-product");
  }
});

$(".selectedVariantid").val($("#sVariantid").text());

$(".o-swatch").click(function () {
  var inp = $(this).find("input");
  var selColor = $(inp).val();
  addSelectedColorImg(selColor);
  // if($('body').hasClass('is-template-product')){
  //   document.body.scrollTop = 0;document.documentElement.scrollTop = 0;
  // }
  $(".selectedVariantid").val($("#sVariantid").text());
});

$(".options-color-wrapper").click(function () {
  var selColor = $(this).attr("data-title");
  addSelectedColorImg(selColor);
  const varId = $(this).attr("data-var_id");
  console.log("varId::", varId);
  if (varId == "51721464152397") {
    $(".afsz-prod-gallery .credentials-img").eq(0).css("display", "none");
  } else {
    $(".afsz-prod-gallery .credentials-img").eq(0).css("display", "");
  }

  

  // 情人节赠品图片切换
  // const VALENTINE_VARIANT_MAP = {
  //   "52207583396173": "52265609691469",
  //   "52207583428941": "52265609724237",
  //   "52821805433165": "53256197800269"
  // };

  // const targetVariantId = VALENTINE_VARIANT_MAP[String(varId)];
  // if (!targetVariantId) return;

  // const $images = $(".benefit-wrapper .product-wrapper .left-wrapper .valentine-variant-image-wrapper");
  // const $prices = $(".benefit-wrapper .product-wrapper .right-wrapper .prices .price");

  // // 切换 active
  // $images.removeClass("is-active");
  // $prices.removeClass("is-active");

  // const $activeImage = $images
  //   .filter(`[data-variant-id="${targetVariantId}"]`)
  //   .addClass("is-active");

  // const $activePrice = $prices
  //   .filter(`[data-variant-id="${targetVariantId}"]`)
  //   .addClass("is-active");

  // // 判断 active 是否 sold out
  // const available = !$activeImage.hasClass("sold-out");

  // // 设置到最近的 product-wrapper
  // $activeImage
  //   .closest(".product-wrapper")
  //   .attr("data-id", targetVariantId)
  //   .attr("data-available", available);

  // if(!available) {
  //   $activeImage.closest(".product-wrapper").removeClass('active')
  // }else {
  //   $activeImage.closest(".product-wrapper").addClass('active')
  // }
});

var now_product_handle = $(".c-variant-selector__swatches-wrapper").attr(
  "product-handle"
);

if (
  now_product_handle == "opencomm2uc" ||
  now_product_handle == "opencomm2uc2025upgrade" ||
  now_product_handle == "openmeet"
) {
  //处理openrun加磁浮类型2uc产品无法展示橱窗图
  var sCol = $(".c-variant-selector__swatches-wrapper").attr("value");
  sCol = sCol.replace(" ", "-/-");
  addSelectedColorImg(sCol);
} else {
  var sCol = $(".c-variant-selector__swatches-wrapper").attr("value");
  addSelectedColorImg(sCol);
}

if ($(".connectivity.o-toggle .o-toggle__switch.is-active").length > 0) {
  addSelectedColorImg("USB-A");
}

function addSelectedColorImg(col) {
  var norm = normalizeGalleryFilterKey(col);
  var newCol = norm.newCol;
  var selectedColor = norm.selectedColor;

  if ($(".afsz-prod-wrapper").hasClass("fl")) {
    // console.log(selectedColor,"selectedColor");
    $(".afsz-prod-wrapper.fl .afsz-thumbs").slick("slickUnfilter");
    $(".afsz-prod-wrapper.fl .afsz-thumbs").slick("slickFilter", selectedColor);
    $(".afsz-prod-wrapper.fl .afsz-thumbs").slick("slickGoTo", 0);

    $(".afsz-prod-wrapper.fl .afsz-fullimages").slick("slickUnfilter");
    $(".afsz-prod-wrapper.fl .afsz-fullimages").slick(
      "slickFilter",
      selectedColor
    );
    $(".afsz-prod-wrapper.fl .afsz-fullimages").slick("slickGoTo", 0);
    setTimeout(function () {
      $(".afsz-prod-wrapper.fl .afsz-thumbs").slick("slickGoTo", 0);
      $(".afsz-prod-wrapper.fl .afsz-fullimages").slick("slickGoTo", 0);
      $(".afsz-thumbs .afsz-thumbs__thumb").click(function () {
        let now_index =
          parseInt($(this).attr("data-slick-index")) % slidesToScroll_pc;
        setTimeout(function () {
          console.log(now_index);
          $(".afsz-prod-wrapper.fl .afsz-fullimages").slick(
            "slickGoTo",
            now_index
          );
        }, 500);
      });
      updatePdpGalleryDebugPanel(col, selectedColor);
    }, 120);

    // $('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickUnfilter');
    //  	$('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickFilter',selectedColor);
    //    $('.afsz-prod-wrapper.fl .afsz-fullimagesM').slick('slickGoTo', 0);
  }
  updatePdpGalleryDebugPanel(col, selectedColor);
}

function refreshPdpGalleryDebugFromDom() {
  if (!isPdpGalleryDebug()) return;
  var col =
    $pdpColorSwatchLabels().filter(".active").first().attr("data-title") ||
    $(".c-variant-selector__swatches-wrapper").attr("value") ||
    "";
  var norm = normalizeGalleryFilterKey(col);
  updatePdpGalleryDebugPanel(col, norm.selectedColor);
}

$(function () {
  if (!isPdpGalleryDebug()) {
    return;
  }
  setTimeout(refreshPdpGalleryDebugFromDom, 400);
  if (window.__pdpGalleryDebugBound) {
    return;
  }
  window.__pdpGalleryDebugBound = true;
  $(document).on("click", ".options-color-wrapper", function () {
    setTimeout(refreshPdpGalleryDebugFromDom, 120);
  });
  $(document).on("click", ".toggle-product-size-item, .toggle-product-size-new .toggle-product-size-item", function () {
    setTimeout(refreshPdpGalleryDebugFromDom, 200);
  });
  $("form.product-single__form select[name=id], form[data-product-form] select[name=id]").on("change", function () {
    setTimeout(refreshPdpGalleryDebugFromDom, 80);
  });
});
